import React from "react";
import Image1 from "./images/w098.jpg";
import Image2 from "./images/w111.jpg";
import Image3 from "./images/w135.jpg";
import Button from "../includes/button";

const Gallery = () => {
    return (
        <div className="flex flex-row lg:flex-col flex-wrap gap-4 w-full lg:h-[562px] h-auto">
            <img src={Image1} alt="PMG team collaborating on a client project" loading="lazy" decoding="async" width="800" height="562" className="w-2/3 h-[562px] object-cover flex-auto rounded-xl"/>
            <img src={Image2} alt="PMG project manager leading a strategy session" loading="lazy" decoding="async" width="400" height="268" className="w-1/3 object-cover object-[50%_65%] flex-auto h-[268px] rounded-xl"/>
            <img src={Image3} alt="PMG fractional PM team working with a client" loading="lazy" decoding="async" width="400" height="268" className="w-1/3 object-cover object-[50%_80%] flex-auto h-[268px] rounded-xl"/>
        </div>
    )
}

const Mission = () => {
    return (
        <div className="container mx-auto text-left flex flex-col gap-6 lg:gap-10 pb-20 px-6">
            <Gallery />
            <p className="leading-tight lg:leading-tight text-2xl md:text-4xl lg:text-6xl font-sans font-light pointer-events-none text-blue20">
                Our mission is to provide <span className="font-bold text-blue10">client-first</span> fractional services that prioritize <span className="font-bold text-blue10">measurable results.</span> 
            </p>
            <Button to="/about" label="Why PMG?" variant="light-secondary" isHashLink={false} />
        </div>   
    )
}


export default Mission;